import * as React from 'react';
import * as _ from 'lodash';
import {
  Logging,
  UserInfo,
  UserContext,
  PermissionGroup,
  getViewPermission,
  CustomerSummary,
} from '@vcd-ecm-ui/Common';
import SideBySideViewerChildCustomerTabProps from './sbsChildCustomersTabProps.interface';
import '../../sidebyside-viewer.scss';

const SideBySideViewerChildCustomerTab = ({
  certificate,
  childCustomers,
  editable,
}: SideBySideViewerChildCustomerTabProps): JSX.Element => {
  // Get the User Context
  const userContext: UserInfo = React.useContext(UserContext);

  // Get the Customers View Permission
  const permissionCustomersView: boolean = getViewPermission(userContext, PermissionGroup.Customers);

  const getChildCustomers = (): JSX.Element[] => {
    Logging.Info('Child Customers', childCustomers);

    // eslint-disable-next-line arrow-body-style
    return childCustomers.map((customer: CustomerSummary) => {
      return (
        <div key={customer.customerUuid} className="field100 sbsChildCustomer">
          <div className="sbsChildCustomerCode">
            {
              permissionCustomersView
                ? (
                  <a className="sbsChildCustomerLink" href={`#/customer/view/${customer.customerUuid}/1`}>{customer.customerCode}</a>
                )
                : (
                  <>{customer.customerCode}</>
                )
            }
          </div>
          <div className="sbsChildCustomerName">
            {customer.customerName}
          </div>
        </div>
      );
    });
  };

  return (
    <>
      <div id="child-customers-tab" className="sbsContentLeftTabContent">
        <div className="field100 sbsChildCustomer">
          <div className="sbsChildCustomerCode sbsChildCustomerHeading">
            Customer Code
          </div>
          <div className="sbsChildCustomerName sbsChildCustomerHeading">
            Customer Name
          </div>
        </div>
        <br />
        {getChildCustomers()}
      </div>
    </>
  );
};

export default SideBySideViewerChildCustomerTab;
